module.exports = __webpack_public_path__ + "img/card-feature.eb90acb5.png";